import React, { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

const Cursor = () => {
    const cursorRef = useRef(null);
    const followerRef = useRef(null);

    useGSAP(() => {
        const cursor = cursorRef.current;
        const follower = followerRef.current;

        if (window.innerWidth < 768) return; // Disable on mobile

        gsap.set(cursor, { xPercent: -50, yPercent: -50 });
        gsap.set(follower, { xPercent: -50, yPercent: -50 });

        const xTo = gsap.quickTo(cursor, "x", { duration: 0.1, ease: "power3.out" });
        const yTo = gsap.quickTo(cursor, "y", { duration: 0.1, ease: "power3.out" });
        const xToFollower = gsap.quickTo(follower, "x", { duration: 0.6, ease: "power3.out" });
        const yToFollower = gsap.quickTo(follower, "y", { duration: 0.6, ease: "power3.out" });

        window.addEventListener("mousemove", (e) => {
            xTo(e.clientX);
            yTo(e.clientY);
            xToFollower(e.clientX);
            yToFollower(e.clientY);
        });

        // Hover effects
        const handleHover = () => {
            gsap.to(cursor, { scale: 0.5, duration: 0.3 });
            gsap.to(follower, { scale: 3, backgroundColor: "rgba(0, 210, 255, 0.1)", borderColor: "transparent", duration: 0.3 });
        };

        const handleBlurHover = () => {
            gsap.to(cursor, { scale: 0.5, duration: 0.3 });
            gsap.to(follower, { 
                scale: 6, 
                backgroundColor: "rgba(255, 255, 255, 0.1)", 
                backdropFilter: "blur(4px)",
                borderColor: "transparent", 
                duration: 0.3 
            });
        };

        const handleUnhover = () => {
             gsap.to(cursor, { scale: 1, duration: 0.3 });
             gsap.to(follower, { 
                 scale: 1, 
                 backgroundColor: "transparent", 
                 borderColor: "var(--cursor-color)", 
                 backdropFilter: "blur(0px)",
                 duration: 0.3 
             });
        };

        const links = document.querySelectorAll("a, button, .cursor-hover");
        links.forEach(link => {
            link.addEventListener("mouseenter", handleHover);
            link.addEventListener("mouseleave", handleUnhover);
        });

        const blurLinks = document.querySelectorAll(".cursor-blur");
        blurLinks.forEach(link => {
            link.addEventListener("mouseenter", handleBlurHover);
            link.addEventListener("mouseleave", handleUnhover);
        });
        
        // Dynamic Update for new elements (Simple Interval Check for this context)
        // Ideally use MutationObserver, but for now simple re-scan on mousemove lightly or just rely on static
        
        return () => {
            window.removeEventListener("mousemove", () => {}); 
            links.forEach(link => {
                link.removeEventListener("mouseenter", handleHover);
                link.removeEventListener("mouseleave", handleUnhover);
            });
            blurLinks.forEach(link => {
                link.removeEventListener("mouseenter", handleBlurHover);
                link.removeEventListener("mouseleave", handleUnhover);
            });
        };

    });

    return (
        <>
            <div ref={cursorRef} className="fixed top-0 left-0 w-3 h-3 bg-designColor rounded-full pointer-events-none z-[9999] hidden md:block mix-blend-difference"></div>
            <div ref={followerRef} className="fixed top-0 left-0 w-8 h-8 border border-designColor rounded-full pointer-events-none z-[9999] hidden md:block transition-colors duration-300" style={{ borderColor: "var(--cursor-color)" }}></div>
        </>
    );
};

export default Cursor;
